import { ClipLoader } from "react-spinners";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { safeJsonParse } from "./productUtils";

function FashionCard({
  fashion,
  editing,
  editValues,
  saveLoadingId,
  deleting,
  imageIndexes,

  setImageIndexes,
  setExtraImages,
  handleEdit,
  handleInputChange,
  handleImageChange,
  handleSave,
  handleDeleteClick,
}) {
  const isEditing = editing === fashion.$id && editValues.type === "fashion";
  const extras = safeJsonParse(fashion.extraFashionUrls, []);
  const currentIndex = imageIndexes[fashion.$id] || 0;

  const goLeft = (e) => {
    e.stopPropagation();

    const max = extras.length;

    setImageIndexes((prev) => ({
      ...prev,
      [fashion.$id]: ((prev[fashion.$id] || 0) - 1 + max + 1) % (max + 1),
    }));
  };

  const goRight = (e) => {
    e.stopPropagation();

    const max = extras.length;

    setImageIndexes((prev) => ({
      ...prev,
      [fashion.$id]: ((prev[fashion.$id] || 0) + 1) % (max + 1),
    }));
  };

  return (
    <div className="product-item">
      <div className="product-image-wrapper">
        <button className="product-arrow left" onClick={goLeft}>
          <FaChevronLeft size={20} />
        </button>

        <img
          src={currentIndex > 0 ? extras[currentIndex - 1] : fashion.fashionUrl}
          alt={fashion.itemName}
          className="product-image"
        />

        <button className="product-arrow right" onClick={goRight}>
          <FaChevronRight size={20} />
        </button>
      </div>

      {isEditing ? (
        <div>
          <div className="tutorial-yp">
            <p>Name:</p>
            <input
              type="text"
              name="name"
              value={editValues.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>₹ </p>
            <input
              type="number"
              name="cost"
              value={editValues.cost}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>Image:</p>
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </div>

          <div className="tutorial-yp">
            <p>Extras:</p>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => setExtraImages(Array.from(e.target.files))}
            />
          </div>

          <button
            className="save-button"
            onClick={() => handleSave(fashion)}
            disabled={saveLoadingId === fashion.$id}
          >
            {saveLoadingId === fashion.$id ? (
              <ClipLoader size={14} color="#fff" />
            ) : (
              "Save"
            )}
          </button>
        </div>
      ) : (
        <div className="yourprod-details">
          <div className="yourprod-detail">
            <p>Item Name:</p> {fashion.itemName}
          </div>

          <div className="yourprod-detail">
            <p>Cost:</p>₹{fashion.cost}
          </div>
        </div>
      )}

      <div>
        <button
          className="edit-button"
          onClick={() => handleEdit(fashion, "fashion")}
        >
          {isEditing ? "Close" : "Edit"}
        </button>

        <button
          className="delete-button"
          onClick={() => handleDeleteClick(fashion.$id, "fashion")}
          disabled={deleting === fashion.$id}
        >
          {deleting === fashion.$id ? <ClipLoader size={12} /> : "Delete"}
        </button>
      </div>
    </div>
  );
}

export default FashionCard;
